import { Autocomplete, TextField } from "@mui/material"
import { useCallback, useEffect, useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { useDependencyInjection } from "../../config/di/dependency_injection_context";
import { ContratoDropDown } from "../domain/models/contrato_dropdown";

/**
 * DropDownContrato
 */
type Props<F extends {}> = {
  name: keyof F,
  label?: string,
  required?: boolean,
  readOnly?: boolean,
  placeholder?: string,
  reactHookForm: UseFormReturn<F>,

};

export const DropDownContrato = <F extends {},>({
  name,
  required,
  readOnly,
  placeholder,
  reactHookForm,

}: Props<F>) => {

  const [contratoDropDown, setContratoDropDown] = useState<ContratoDropDown[]>([]);

  const {
    commons: { getContratoDropDownUseCase },
  } = useDependencyInjection();

  //Load contrato DropDown

  const loadContratoDropDown = useCallback(async () => {
    try {
      const contrato = await getContratoDropDownUseCase.getContratoDropDown();
      setContratoDropDown(contrato);
    } catch (e: unknown) {
      console.error("Erro ao carregar contrato:", e);
    }
  }, [getContratoDropDownUseCase]);

  useEffect(() => {
    loadContratoDropDown();
  }, [loadContratoDropDown]);


  return (
    <>

      {/*contrato DropDown */}

      <Controller
        name={name as any}
        control={reactHookForm.control}
        render={({ field, formState }) => {
          let helperText: string | null = null;

          if (formState.errors[name as keyof typeof formState.errors]) {
            const fieldError = formState.errors[name] as any;
            if (fieldError?.message && typeof fieldError.message === 'string') {
              helperText = fieldError.message;
            }
          }


          return (
            <Autocomplete
              fullWidth={true}
              size="small"
              disablePortal
              options={contratoDropDown}
              getOptionKey={opt => opt.codigo}
              getOptionLabel={(opt) => opt.codigoDescricao}
              isOptionEqualToValue={(opt, val) => opt.codigo === val.codigo}
              sx={{ minHeight: 45 }}
              readOnly={readOnly}
              disabled={formState.disabled}
              value={contratoDropDown.find(x => x.codigo === field.value) ?? null}
              onChange={(_, newValue) => { field.onChange(newValue ? newValue.codigo : undefined); }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="Contrato"
                  error={helperText !== null}
                  helperText={helperText}
                  placeholder={placeholder}
                  required={required}
                />
              )}
            />
          );
        }}
      />
    </>
  );
};
